<template>
    <div data-loader aria-busy="true">
        <div data-balls>
            <span data-ball1></span>
            <span data-ball2></span>
            <span data-ball3></span>
        </div>
    </div>
</template>

<script>
export default {
    name: `visual-loader`,
};
</script>

<style lang="scss" scoped>
[data-loader] {
    z-index: 9999;
    content: "";
    background: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: fade 1.2s forwards;
}

[data-balls] {
    z-index: 100;

    [data-ball1] {
        animation-delay: -0.32s;
    }

    [data-ball2] {
        animation-delay: -0.16s;
    }

    > span {
        width: 25px;
        margin: 0 1px;
        height: 25px;
        background-color: var(--primary-color);
        border-radius: 100%;
        display: inline-block;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }
}

@keyframes sk-bouncedelay {
    0%,
    100% {
        transform: scale(0.1);
    }

    50% {
        transform: scale(1);
    }
}

@keyframes fade {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
</style>